import initialFilters from "../store/modules/filters.initialFilters";

export const FILTER_IS_FAVORITE = {
  isTriState: true,
  default: true,
  exclude: false,
  value: "isFavorite",
  name: "FILTER_IS_FAVORITE",
  icons: [
    {
      values: ["true"],
      icon: "isFavorite"
    },
    {
      values: ["false"],
      icon: "isFavoriteNot"
    },
    {
      values: [],
      icon: "isFavoriteNeutral"
    }
  ],
  label: "favorites",
  weight: 10,
  labels: [
    {
      values: ["true"],
      text: "Nur Favoriten"
    },
    {
      values: ["false"],
      text: "Keine Favoriten"
    },
    {
      values: [],
      text: "Alle Hinweise"
    }
  ]
};

export const FILTER_IS_TOP = {
  isTriState: true,
  default: true,
  exclude: false,
  value: "isTop",
  name: "FILTER_IS_TOP",
  icons: [
    {
      values: ["true"],
      icon: "isTop"
    },
    {
      values: ["false"],
      icon: "isTopNot"
    },
    {
      values: [],
      icon: "isTopNeutral"
    }
  ],
  label: "topEvents",
  labels: [
    {
      values: ["true"],
      text: "Nur Top-Inhalte"
    },
    {
      values: ["false"],
      text: "Keine Top-Inhalte"
    },
    {
      values: [],
      text: "Alle Inhalte"
    }
  ],
  weight: 20
};

export const FILTER_TYPE = {
  // isBiState: true,
  default: [],
  path: "",
  exclude: false,
  label: "Typ auswählen",
  value: "type",
  name: "FILTER_TYPE",
  // labels: [
  //   'Nur',
  //   'Keine',
  // ],
  isArray: true,
  logicalOr: true,
  weight: 30
};

export const FILTER_IS_TOPIC = {
  isBiState: true, // NB: Only visual flag
  default: true,
  exclude: false,
  value: "isTopic",
  name: "FILTER_IS_TOPIC",
  label: "topics",
  // labels: {
  //   1: 'Nur Themen',
  //   2: 'Keine Themen',
  // },
  labels: [
    {
      values: ["true"],
      text: "Nur Themen"
    },
    {
      values: ["false"],
      text: "Keine Themen"
    }
  ],
  weight: 30
};

export const FILTER_REGION = {
  default: [],
  path: "",
  exclude: "exclude",
  value: "geoscope",
  name: "FILTER_REGION",
  isArray: true,
  logicalOr: true,
  // label: 'Bundesland',
  // labels: {
  // 0: 'Bundesland',
  // },
  weight: 40,
  items: [
    "Baden-Württemberg",
    "Bayern",
    "Berlin",
    "Brandenburg",
    "Bremen",
    "Hamburg",
    "Hessen",
    "Mecklenburg-Vorpommern",
    "Niedersachsen",
    "Nordrhein-Westfalen",
    "Rheinland-Pfalz",
    "Saarland",
    "Sachsen",
    "Sachsen-Anhalt",
    "Schleswig-Holstein",
    "Thüringen"
  ]
};

export const FILTER_CITY = {
  default: {
    city: ""
  },
  path: "city",
  exclude: "exclude",
  value: "address",
  name: "FILTER_CITY",
  // label: 'Veranstaltungsort',
  // labels: {
  // 0: 'Veranstaltungsort',
  // },
  weight: 50
};

export const FILTER_LOCATION = {
  default: {
    city: ""
  },
  path: "city",
  exclude: "exclude",
  value: "address",
  name: "FILTER_LOCATION",
  weight: 50
};

export const FILTER_IS_COVERAGE_INTENDED = {
  isBiState: true, // NB: Only visual flag
  default: true,
  exclude: false,
  name: "FILTER_IS_COVERAGE_INTENDED",
  value: "coverageIntended",
  label: "coverageIntended",
  labels: [
    {
      values: ["true"],
      text: "Mit dpa-Inhalten"
    },
    {
      values: ["false"],
      text: "Ohne dpa-Inhalte"
    }
  ],
  weight: 60
};

export const FILTER_MATERIAL_TYPE = {
  isBiState: true,
  default: "picture",
  path: "type",
  exclude: "exclude",
  value: "materialPromises",
  name: "FILTER_MATERIAL_TYPE",
  quickFilterRuleChip: {
    values: ["picture"],
    text: "Mit Fotos"
  },
  items: [
    {
      value: "text",
      text: "Text"
    },
    {
      value: "picture",
      text: "Foto"
    },
    {
      value: "graphic",
      text: "Grafik"
    },
    {
      value: "audio",
      text: "Audio"
    },
    {
      value: "video",
      text: "Video"
    }
  ],
  isArray: true,
  weight: 70
};

export const FILTER_CATEGORY = {
  default: {
    code: ""
  },
  path: "code",
  value: "category",
  name: "FILTER_CATEGORY",
  label: "Ressort",
  weight: 0,
  isArray: true,
  logicalOr: true,
  items: initialFilters()
    .filter(filterRule => filterRule.isRessort)
    .map(filter => ({
      text: filter.name,
      value: filter.filterRules.find(
        filterRule => filterRule.type === "FILTER_CATEGORY"
      ).values[0]
    }))
};

// NB: Non-functionial, UI only!
export const FILTER_RELEVANCE = {
  default: [],
  exclude: "exclude",
  isArray: true,
  logicalOr: true,
  label: "Relevanz eingrenzen",
  path: "",
  name: "FILTER_RELEVANCE",
  value: "relevance",
  items: [
    {
      value: "international",
      text: "International"
    },
    {
      value: "national",
      text: "Überregional"
    },
    {
      value: "regional",
      text: "Regional"
    }
  ],
  weight: 110
};

export const FILTER_FILTER = {
  name: "FILTER_FILTER"
};

export default {
  FILTER_CITY,
  FILTER_CATEGORY,
  FILTER_IS_COVERAGE_INTENDED,
  FILTER_IS_FAVORITE,
  FILTER_IS_TOP,
  FILTER_IS_TOPIC,
  FILTER_MATERIAL_TYPE,
  FILTER_TYPE,
  FILTER_REGION,
  FILTER_RELEVANCE,
  FILTER_LOCATION,
  FILTER_FILTER
};
